// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"524f3f24","453":"062e10a6","732":"122a7542"}[chunkId] + ".chunk.js";
};